import FormSection from 'components/FormSection';
import { SelectWithField } from 'components/Selects/Select';
import { PURPOSE_KIND } from 'modules/Inquiry/Form/formFields';
import usePurposeKindOptions from 'modules/Inquiry/Form/Steps/FinancingNeed/Purpose/usePurposeKindOptions';
import { FormSections } from 'schema/inquirySchema.models';
import { useTranslations } from 'utils/hooks/useTranslations';

/**
 * BfS (SozialBank) renders the Finanzierungsanlass selector as a dropdown instead of
 * the tile grid used by the default lane. The available occasions and their order are
 * unchanged — they still come from `usePurposeKindOptions` (backend-driven, FE-sorted) —
 * only the presentation differs. The selected occasion is stored in `PURPOSE_KIND`, so
 * all downstream show/hide and per-occasion sections continue to work as before.
 */
const BfsPurposeSection = () => {
  const t = useTranslations();
  const purposes = usePurposeKindOptions();

  const options = purposes.map(({ key, title }) => ({ value: key, label: title }));

  return (
    <FormSection
      title={t('pages.financingNeed.sections.purpose.title')}
      name={FormSections.purposeKind}
    >
      <SelectWithField
        name={PURPOSE_KIND}
        options={options}
        placeholder={t('placeholders.pleaseChoose')}
        noCaption
        preventEnterInInput
      />
    </FormSection>
  );
};

export default BfsPurposeSection;
